'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

CbsiService.$inject = ['$window'];


var _module = _angular2.default.module('cb.cbsi.CbsiService', []);

_module.service('CbsiService', CbsiService);

exports.default = _module;


function CbsiService($window) {
    var service = {
        getCbsiContext: getCbsiContext,
        isUserLoggedIn: isUserLoggedIn,
        isBusinessCustomer: isBusinessCustomer
    };

    return service;

    function getCbsiContext() {
        if ($window.cbsiContext) {
            return $window.cbsiContext;
        } else {
            return false;
        }
    }

    function isUserLoggedIn() {
        var cbsi = getCbsiContext();

        if (cbsi && cbsi.user && (cbsi.user.isPrivateCustomer || cbsi.user.isPrivateEmployee || cbsi.user.isBusinessCustomer)) {
            return true;
        } else {
            return false;
        }
    }

    function isBusinessCustomer() {
        var cbsi = getCbsiContext();

        if (cbsi && cbsi.user && cbsi.user.isBusinessCustomer) {
            return true;
        } else {
            return false;
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/cbsi/cbsi.service.js
// module id = 770
// module chunks = 0